// extracted by mini-css-extract-plugin
export default {"container":"icon_container__USwIX","iconWrapper":"icon_iconWrapper__IJWfc","icon":"icon_icon__oq1qc"};